/**
 * @des 防抖 ，多次只执行最后一次
 * @param func 需要包装的函数
 * @param delay 延迟时间，单位ms
 * @param immediate 是否默认执行一次(第一次不延迟)
 */
class Debounced {
    public use = (
        func: any,
        delay: number,
        immediate: undefined | boolean = false
    ) => {
        let timer: any;
        return (...args: any) => {
            if (immediate) {
                func.apply(this, args);
                immediate = false;
                return;
            }
            clearTimeout(timer);
            timer = setTimeout(() => {
                func.apply(this, args);
            }, delay);
        };
    };
}
const debounced = new Debounced();
export {debounced}
